import events from "~/mixins/events"

export default {
  layout: "barren",
  mixins: [events],
  validate: function ({ params }) {
    return typeof params.slug === "string"
  },
  asyncData: async function ({ params, $axios, error }) {
    try {
      const ret = await $axios.$get("/influencer/widget/" + params.slug + "/")
      return ret
    } catch (e) {
      error({ message: "Influencer not found", statusCode: 404 })
    }
  },
  data: function () {
    return {
      smallLightPos: {
        transform: "translateX(-" + this.getRandomInt(20, 40) + "vw)",
      },
      bigLightPos: {
        transform: "translateX(-" + this.getRandomInt(10, 20) + "vw)",
      },
      is_exec: false,
      is_init: false,
    }
  },
  computed: {
    link: function () {
      if (process.client)
        return `${window.location.origin}/band/homepage/?add=${this.slug}&utm_source=widget_${this.slug}&widget_id=${this.id}`
      else return null
    },
  },
  mounted: function () {
    var vm = this

    this.initShine()
    this.set_trackers()
    if (process.client) {
      this.trackEvent({
        category: "Visit",
        action: "Widget Visit",
      })
    }
    window.setInterval(function () {
      vm.execShine()
      window.setTimeout(function () {
        vm.initShine()
      }, 4000)
    }, 8000)
  },
  methods: {
    set_trackers: function () {
      console.log("from_widget")
      this.$cookies.set("from_widget", this.id, { maxAge: 60 * 60 * 24 * 7 })
    },
    initShine: function () {
      if (!this.is_init && !this.is_exec) {
        const vm = this

        this.is_init = true
        this.$set(this, "smallLightPos", {
          transform: "translateX(-" + this.getRandomInt(20, 40) + "vw)",
        })
        this.$set(this, "bigLightPos", {
          transform: "translateX(-" + this.getRandomInt(10, 20) + "vw)",
        })
        window.setTimeout(() => {
          vm.is_init = false
        }, 1000)
      }
    },
    execShine: function () {
      if (!this.is_exec && !this.is_init) {
        const vm = this

        this.is_exec = true
        this.$set(this, "smallLightPos", {
          transform: "translateX(" + this.getRandomInt(120, 160) + "vw)",
        })
        this.$set(this, "bigLightPos", {
          transform: "translateX(" + this.getRandomInt(120, 140) + "vw)",
        })
        window.setTimeout(() => {
          vm.is_exec = false
        }, 1000)
      }
    },
  },
}
